<template>
    <div class="back-color">
        <div id="main-wrapper">
            <people-genetics-navbar />

            <div class="page-wrapper">
                <router-view></router-view>
            </div>
        </div>

        <footer style="background-color: #D8EDFE">
            <div class="footer-copyright text-center py-3">
                <div
                    class="container-fluid text-center text-md-left"
                    style="margin-bottom: 15px;"
                >
                    <div class="row">
                        <div class="col-md-4 mt-md-0 mt-3"></div>
                        <div class="col-md-2 mt-md-0 mt-3">
                            <h5 class="text-uppercase font-weight-bold">
                                People genetics
                            </h5>
                            <p>{{ $t("footer.description") }}</p>
                        </div>
                        <hr class="clearfix w-100 d-md-none pb-3" />
                        <div class="col-md-6 mb-md-0 mb-3">
                            <h5 class="text-uppercase font-weight-bold">
                                {{ $t("footer.help") }}
                            </h5>
                            <i class="mdi mdi-email-outline" /><a
                                href="mailto:info@people-genetics.com"
                            >
                                info@people-genetics.com</a
                            >
                        </div>
                    </div>
                </div>
                &copy; {{ currentYear }}
                <a href="https://people-genetics.com"> People-Genetics</a>.
                {{ $t("footer.rights") }}
            </div>
        </footer>
    </div>
</template>

<script>
import moment from "moment";
import PeopleGeneticsNavbar from "./PeopleGeneticsNavbar";

export default {
    components: { PeopleGeneticsNavbar },
    computed: {
        currentYear() {
            return moment().format("YYYY");
        }
    }
};
</script>
